import { DependencyList, useEffect, useRef, useState } from 'react';

type DidUpdateCallback = (prevVars: DependencyList) => void;
export function useDidUpdate(fn: DidUpdateCallback, deps: DependencyList) {
  const prevVars = useRef<DependencyList>(deps);
  const [didMount, setDidMount] = useState(false);
  useEffect(() => {
    setDidMount(true);
  }, []);

  useEffect(() => {
    if (didMount) {
      fn(prevVars.current);
      prevVars.current = deps;
    }
    // eslint-disable-next-line
  }, deps);
}
